import React from 'react';
import About from './About';
import Cart from './Cart';
import Navnew from './Navnew';
class App extends React.Component {

  constructor() {
    super();
    this.state = {
      products: [
        {
          price: 5499,
          title: 'Watch',
          Quantity: 1,
          img: 'https://www.g-central.com/wp-content/uploads/2017/10/Toughest-G-Shock-GX-56BB-1-700x700.jpg',
          id: 1
        },
        {
          price: 18999,
          title: 'Mobile Phone',
          Quantity: 10,
          img: 'https://github.com/DrCybernotix/FireCart/blob/main/imgs/mob.png?raw=true',
          id: 2
        },
        {
          price: 99999,
          title: 'Laptop',
          Quantity: 4,
          img: 'https://github.com/DrCybernotix/FireCart/blob/main/imgs/lap.png?raw=true',
          id: 3
        }
      ]
    }
    // this.increaseQuantity = this.increaseQuantity.bind(this);
    // this.testing();
  }
  handleIncreaseQuantity = (product) => {
    console.log('Increase the Quantity of ', product);
    const { products } = this.state;
    const index = products.indexOf(product);

    products[index].Quantity += 1;

    this.setState({
      products
    })
  }
  handleDecreaseQuantity = (product) => {
    console.log('inc the Quantity of ', product);
    const { products } = this.state;
    const index = products.indexOf(product);

    if (products[index].Quantity === 0) {
      return;
    }

    products[index].Quantity -= 1;

    this.setState({
      products
    })
  }
  handleDeleteProduct = (id) => {
    const { products } = this.state;

    const items = products.filter((item) => item.id !== id); // [{}]

    this.setState({
      products: items
    })
  }

  getCartCount = () => {
    const { products } = this.state;

    let count = 0;

    products.forEach((product) => {
      count += product.Quantity;
    })

    return count;
  }

  getCartTotal = () => {
    const { products } = this.state;

    let cartTotal = 0;

    products.map((product) => {
      cartTotal = cartTotal + product.Quantity * product.price
      return '';
    })

    return cartTotal;
  }
  render() {
    const { products } = this.state;
    document.body.style.backgroundColor = 'white' 
    return (
      <div>
        <Navnew count={this.getCartCount()} />

        <div className="container">

          <Cart
            products={products}
            onIncreaseQuantity={this.handleIncreaseQuantity}
            onDecreaseQuantity={this.handleDecreaseQuantity}
            onDeleteProduct={this.handleDeleteProduct}
          />
          <div style={{ padding: 10, fontSize: 20 }}>Total Price: {this.getCartTotal()} Rs.
          </div>
          <button type="button" className="btn btn-primary mx-2 my-2">Checkout?</button>
          <About/>
        </div>

        {/* <div >Total Price: {this.getCartTotal()} Rs. </div>
       </div> */}
       
      </div>
    );
  }
}

export default App;
